import * as types from './types';

export const refreshInvoices = () => ({
  type: types.CHANGE_INVOICES_VERSION
});
